/**
 * Clave de la caché persistida en localStorage.
 *
 * Vive aparte de main.tsx para que AuthContext pueda borrarla al cerrar sesión
 * sin crear un ciclo de importación entre ambos módulos.
 */
export const CACHE_KEY = 'home-tasks-cache'
